import { Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl, InputLabel, Select, MenuItem, Grid } from '@mui/material';
import { Moment } from 'moment';
import { useEffect, useState } from 'react';
import { PesquisarFluxo } from '../../../../../types/mutations/bpm/pesquisar-fluxo';
import DateComIntervalo from '../../../../../components/DateComIntervalo';

interface FiltrosModalProps {
  open: boolean;
  onClose: () => void;
  modeloFluxo: PesquisarFluxo[];
  fluxoId: number | null;
  dataInicial: Moment | null;
  dataFinal: Moment | null;
  onFluxoChange: (id: number) => void;
  onDataChange: (inicial: Moment | null, final: Moment | null) => void;
  onApply: () => void;
}

export default function FiltrosModal({
  open,
  onClose,
  modeloFluxo,
  fluxoId,
  dataInicial,
  dataFinal,
  onFluxoChange,
  onDataChange,
  onApply
}: FiltrosModalProps) {
  // Local state for form values
  const [localFluxoId, setLocalFluxoId] = useState<number | null>(fluxoId);
  const [localDataInicial, setLocalDataInicial] = useState<Moment | null>(dataInicial);
  const [localDataFinal, setLocalDataFinal] = useState<Moment | null>(dataFinal);

  // Update local state when props change or modal is opened
  useEffect(() => {
    setLocalFluxoId(fluxoId);
    setLocalDataInicial(dataInicial);
    setLocalDataFinal(dataFinal);
  }, [fluxoId, dataInicial, dataFinal, open]);

  const handleApply = () => {
    if (localFluxoId !== null) {
      onFluxoChange(localFluxoId);
    }
    onDataChange(localDataInicial, localDataFinal);
    onApply();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Filtros</DialogTitle>
      <DialogContent>
        {modeloFluxo.length > 0 && (
          <FormControl size="small" sx={{ minWidth: 250, mt: 2, display: 'block' }}>
            <InputLabel id="id-select-label">Fluxo</InputLabel>
            <Select
              labelId="id-select-label"
              label="Fluxo"
              value={localFluxoId || ''}
              sx={{ py: 1, width: '100%' }}
              onChange={(e) => setLocalFluxoId(Number(e.target.value))}
            >
              {modeloFluxo.map((fluxo) => (
                <MenuItem key={fluxo.id} value={fluxo.id}>
                  {fluxo.nome}
                </MenuItem>
              ))}
            </Select>
            <Grid size={{ xs: 12 }} mt={2}>
              <DateComIntervalo
                data={{
                  inicial: localDataInicial,
                  final: localDataFinal
                }}
                onChangeData={(data) => {
                  setLocalDataInicial(data.inicial);
                  setLocalDataFinal(data.final);
                }}
                datePickerView={['year', 'month', 'day']}
                formatString="DD/MM/YYYY"
                labelInput="Período de análise"
              />
            </Grid>
          </FormControl>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={handleApply}
          variant="contained"
          color="primary"
          disabled={localFluxoId == null}
        >
          Aplicar
        </Button>
      </DialogActions>
    </Dialog>
  );
}